<template>
  <div class="page">
    <navigation :showBack="false" :sticky="true">提款确认</navigation>
    <section class="top padding-h-30">
      <div class="confirm-amount rounded-10">
        <img src="./image/header-tips.png">
        <div class="right">
          <div class="header">
            <div class="font-title">确认提现金额</div>
            <div class="status color-primary">待确认</div>
          </div>
          <div class="content">提现金额变动：根据您的信用评估，专属资金通道本次批核<span class="color-primary">{{ info.loanPrin }}元</span>额度，请确认以此金额进行本次提现申请</div>
        </div>
      </div>
      <div class="confirmed rounded-10 bg-white margin-top-10">
        <div class="left">
          <img src="./image/icon_02@2x.png">
          <span class="font-desc font-color-light-gray">确认打款通道</span>
        </div>
        <div class="right font-color-light-gray">
          <div class="status">已确认</div>
          <div class="date-time">{{ info.auditTime | date('MM/DD hh:mm:ss')}}</div>
        </div>
      </div>
      <div class="confirmed rounded-10 bg-white margin-top-10">
        <div class="left">
          <img src="./image/icon_02@2x.png">
          <span class="font-desc font-color-light-gray">校验提现资格</span>
        </div>
        <div class="right font-color-light-gray">
          <div class="status">已通过</div>
          <div class="date-time">{{ info.commitAuditTime | date('MM/DD hh:mm:ss')}}</div>
        </div>
      </div>
    </section>
    <section class="loan-parameters">
      <div class="font-title padding-h-30">提现要素</div>
      <div class="info bg-white margin-top-10">
        <div class="amount-term">
          <div class="title font-desc font-color-gray">提现金额/期数</div>
          <div class="detail font-title">{{info.loanPrin | currency}}元/{{ info.loanTerm }}期</div>
        </div>
        <div class="rate">
          <div class="title">综合年化利率/应还总息费</div>
          <div class="detail font-title">{{info.intRate * 100 | currency }}%/{{ info.interestFee | currency }}元</div>
        </div>
      </div>
      <div class="card bg-white margin-top-10">
        <div>收款账户</div>
        <div>{{ bankCardNoText }}</div>
      </div>
    </section>
    <section class="loan-plan padding-h-30">
      <div class="head">
        <div class="font-title">还款计划</div>
        <div class="desc font-desc font-color-light-gray">（还款实际到期日以实际放款时间为准）</div>
      </div>
      <div class="terms bg-white rounded-10">
        <div class="table-header">
          <div class="header-item term-number">期数</div>
          <div class="header-item due-date">到期日</div>
          <div class="header-item repay-amount">当期应还 (元)</div>
        </div>
        <div class="table">
          <div v-for="term in info.termInfo" :key="term.termNo" class="row">
            <div class="term-number">{{ termFormat(term.termNo) }}/{{ termFormat(info.termInfo.length) }}</div>
            <div class="due-date">{{ term.paidOutDate | date('YYYY/MM/DD')}}</div>
            <div class="repay-amount">{{ term.schdAmt }}</div>
          </div>
        </div>
      </div>
    </section>
    <section class="great-vip bg-white" :class="{flash: checkGreatVIP === 'N'}">
      <div class="title">
        <div class="font-title">{{ info.loanProcessTitle }}</div>
        <img
          src="./image/icon_info_w@2x.png"
          class="title-icon"
          @click="bvipVisible=true"
        >
      </div>
      <div class="content font-desc font-color-gray">
        <div class="left">畅享最高价值{{ info.greatVIPCoupon.maxAmount }}元特权礼包</div>
        <div class="right">
          <div>{{ info.greatVIPCoupon.termAmount }}元/期 (共{{ info.greatVIPCoupon.countTerm }}期)</div>
          <img
            v-if="checkGreatVIP === 'Y'"
            src="./image/icon_checkmark_circle.png"
            @click="checkGreatVIP='N'"
          >
          <img
            v-else
            src="./image/icon_uncheckmark_circle.png"
            @click="checkGreatVIP='Y'"
          >
        </div>
      </div>
    </section>
    <section class="actions bg-white">
      <div class="count-down-bg">
        <template v-if="countdownVisible">
          <div class="count-down-tip">提现订单即将关闭，请立即确认</div>
          <van-count-down :time="countdownDuration" @finish="countDownEnd">
            <template #default="timeData">
              <span class="block">{{ timeFormat(timeData.hours) }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeFormat(timeData.minutes) }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeFormat(timeData.seconds) }}</span>
            </template>
          </van-count-down>
        </template>
      </div>
      <nd-button
        class="confirm-button"
        :disabled="cantWithdraw"
        @click="handlePreCheck"
      >
        立即确认提现
      </nd-button>
      <div class="protocol font-color-light-gray">点击「立即确认提现」按钮，表示您已阅读并同意<a @click.stop="viewProtocol">《相关协议》</a></div>
    </section>

    <bvip-tips-dialog v-model="bBvipTipsVisible" :loanProcessTitle="info.loanProcessTitle" @on-next="confirmAction"></bvip-tips-dialog>
    <bvip-action-sheet v-model="bvipActionSheetVisible" :loanProcessTitle="info.loanProcessTitle" :greatVIPCoupon="info.greatVIPCoupon" @on-protocol="viewProtocol" @on-withdraw="actionWithdraw"></bvip-action-sheet>

    <bvip-intro-dialog
      v-model="bvipVisible"
      :content="info.greatVIPCoupon.couponPopupDesc"
    ></bvip-intro-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getKey, isEmptyObject } from '../../assets/utils'
import BvipIntroDialog from './components/bvip-intro-dialog.vue'
import { CountDown } from 'vant'
import withdrawConfig from '@/view/withdraw/assets/withdrawConfig.js'
export default {
  name: 'BizLimitUpConfirm',
  mixins: [withdrawConfig],
  components: {
    BvipIntroDialog,
    CountDown
  },
  data () {
    return {
      info: {
        greatVIPCoupon: {
          maxAmount: 0,
          termAmount: 0,
          countTerm: 0
        }
      },
      selectedBankcard: {},
      bvipVisible: false,
      loanSerialNo: this.$route.query.loanSerialNo,
      checkGreatVIP: 'Y'
    }
  },
  computed: {
    countdownVisible () {
      const now = new Date().getTime()
      return this.info.guideExpireTime > now
    },
    countdownDuration () {
      return this.info.guideExpireTime - new Date().getTime()
    },
    bankCardNoText () {
      if (this.selectedBankcard?.bankCardNo) {
        const code = this.selectedBankcard.bankCardNo.substr(-4, 4)
        return `${this.selectedBankcard.bankName} (${code})`
      } else {
        return '去绑卡'
      }
    },
    trafficCode () {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      return trafficCode
    }
  },
  watch: {
    checkGreatVIP (value) {
      if (this.info.loanProcess === 'GVIP' && this.style === 'A') {
        this.$message('今日额度已抢完')
      }
    }
  },
  async created () {
    await this.getLoanTrial()
    await this.getBankcardList()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('withdraw', ['getBizLimitUpLoanTrial', 'bizLimitUpConfirm', 'bizLimitUpClose']),
    ...mapActions('bankcard', ['getBankcardListX']),
    // 新合规流程校验  mixins: withdrawConfig
    handlePreCheck () {
      if (this.style === 'B') {
        this.showStyleB()
        return
      }
      if (this.showDialogTips) {
        this.bBvipTipsVisible = true
        return
      }
      if (this.unCheckLead) {
        this.bvipActionSheetVisible = true
        return
      }
      this.confirmAction()
    },
    actionWithdraw () {
      this.checkGreatVIP = 'Y'
      this.confirmAction()
    },

    async getLoanTrial () {
      const { success, data } = await this.getBizLimitUpLoanTrial({
        guideBizProcess: 'BIZ_ADJUST_AMOUNT',
        loanSerialNo: this.loanSerialNo,
        checkGreatVIP: this.checkGreatVIP,
        productCode: 'TMDP',
        ...this.trafficCode
      })
      if (success) {
        this.info = data
        this.complianceConfig = data.complianceConfig || {}
        this.checkGreatVIP = data.complianceConfig.defaultCheck
        this.mustCheck = data.mustCheck
      }
    },
    async getBankcardList () {
      const { success, data } = await this.getBankcardListX({
        loanPlatform: 'TMD',
        fundCode: this.info.previousFundCode,
        productCd: 'TMDP'
      })
      if (success && data.length > 0) {
        if (this.info.previousBankCardNo) {
          this.selectedBankcard = data.filter(item => item.bankCardNo === this.info.previousBankCardNo)[0]
        } else {
          const bank = this.$store.state.bankcard.selectedBankcard
          const defaultBank = data.filter((item) => item.defalt)
          const defaultBankCard = defaultBank.length > 0 ? defaultBank[0] : null
          this.selectedBankcard = !isEmptyObject(bank) && data.filter(item => item.bankCardNo === bank.bankCardNo).length !== 0
            ? data.filter(item => item.bankCardNo === bank.bankCardNo)[0]
            : defaultBankCard || data[data.length - 1]
        }
      }
    },
    async confirmAction () {
      const { success, data } = await this.bizLimitUpConfirm({
        guideBizProcess: 'BIZ_ADJUST_AMOUNT',
        loanSerialNo: this.loanSerialNo,
        checkGreatVIP: this.checkGreatVIP,
        productCode: 'TMDP',
        ...this.trafficCode
      })
      if (success) {
        this.$router.replace({
          path: '/withdraw/result',
          query: {
            loanApplyNo: data.loanApplyNo,
            noDialog: 'T'
          }
        })
      }
    },
    viewProtocol () {
      this.$router.push({
        path: '/withdraw/protocol',
        query: {
          fundCode: this.info.previousFundCode,
          busiType: 'LOAN',
          loanProcess: this.info.loanProcess
        }
      })
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    termFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num
    },
    async countDownEnd () {
      const { success } = await this.bizLimitUpClose({
        guideBizProcess: 'BIZ_ADJUST_AMOUNT',
        loanSerialNo: this.loanSerialNo,
        productCode: 'TMDP',
        ...this.trafficCode
      })
      if (success) {
        this.backHome(true)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

@keyframes shine {
  0% {
    background-color: #ffffff;
  }

  16.7% {
    background-color: #ffddd9;
  }

  33.3% {
    background-color: #ffffff;
  }

  50% {
    background-color: #ffddd9;
  }

  66.7% {
    background-color: #ffffff;
  }

  83.3% {
    background-color: #ffddd9;
  }

  100% {
    background-color: #ffffff;
  }
}
.page {
  min-height: 100%;
  box-sizing: border-box;
  background-color: rgba(250, 250, 250, 1);
  padding-bottom: 284px;
  .top {
    margin-top: 20px;
    .confirm-amount {
      background-color: rgba(254,233,232,0.6);
      padding: 18px;
      display: flex;
      flex-direction: row;
      img {
        width: 54px;
        height: 54px;
      }
      .right {
        margin-left: 8px;
        .header {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .status {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 22px;
            line-height: 30px;
          }
        }
        .content {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          line-height: 33px;
        }
      }
    }
    .confirmed {
      padding: 13px 20px 13px 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 54px;
          height: 54px;
        }
        span {
          line-height: 37px;
          margin-left: 8px;
        }
      }
      .right {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        line-height: 30px;
        text-align: right;
      }
    }
  }
  .loan-parameters {
    margin-top: 40px;
    .info {
      padding: 20px 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: left;
    }
    .card {
      padding: 34px 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 30px;
      color: #333333;
      line-height: 42px;
    }
  }
  .loan-plan {
    margin-top: 40px;
    .head {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .desc {
        line-height: 50px;
      }
    }
    .terms {
      .table-header {
        margin-top: 11px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding-top: 23px;
        padding-bottom: 7px;
        border-bottom: 1px solid #EEE;
        .header-item {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 27px;
          color: #333333;
          line-height: 50px;
          text-align: center;
          &.term-number {
            width: 30%;
          }
          &.due-date {
            width: 32%;
          }
          &.repay-amount {
            width: 33%;
          }
        }
      }
      .table {
        padding: 19px 0;
        .row {
          padding: 11px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          align-items: center;
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 22px;
          color: #333333;
          line-height: 30px;
          .term-number {
            width: 30%;
          }
          .due-date {
            width: 32%;
          }
          .repay-amount {
            width: 33%;
          }
        }
      }
    }
  }
  .great-vip {
    margin-top: 40px;
    padding: 28px 22px 28px 30px;
    .title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .title-icon {
        width: 26px;
        height: 26px;
        margin-left: 7px;
      }
    }
    .content {
      margin-top: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      line-height: 37px;
      .right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .actions {
    padding: 20px 39px 28px;
    width: 100%;
    height: 264px;
    position: fixed;
    bottom: 0;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .count-down-bg {
      width: 670px;
      height: 116px;
      background: #FEE9E8;
      border-radius: 14px 14px 20px 0px;
      padding: 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .count-down-tip {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #333333;
        line-height: 40px;
      }
      .van-count-down {
        margin: 0 5px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        line-height: 44px;
        .colon {
          color: #FE877B;
        }
        .block {
          display: inline-block;
          width: 44px;
          height: 44px;
          background: #FE877B;
          border-radius: 4px;
          text-align: center;
          color: #fff;
        }
      }
    }
    .confirm-button {
      margin-top: -44px;
      width: 670px;
      height: 88px;
    }
    .protocol {
      margin-top: 25px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      a {
        color: #8EB2D8;
        line-height: 33px;
      }
    }
  }
}
.bg-white {
  background-color: #fff;
}
.padding-h-30 {
  padding-left: 30px;
  padding-right: 30px;
}
.margin-top-10 {
  margin-top: 10px;
}
.rounded-10 {
  border-radius: 10px;
}
.font-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 30px;
  color: #333333;
  line-height: 50px;
}
.font-desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
}
.font-color-gray {
  color: #666666;
}
.font-color-light-gray {
  color: #999999;
}
.color-primary {
  color: #FF4633;
}
.flash {
  animation: shine 3000ms infinite;
}
</style>